import React, { useEffect, Fragment, useRef } from 'react';
import './episode.scss';
// import playIcon from '../../assets/play.svg';
import { episodeData } from './episodeData';
import { ReactComponent as PlayIcon } from '../../assets/play.svg';

function Episode({ videoSrc, dataIndex, episodeRef }) {
  const videoRef1 = useRef();
  const videoRef2 = useRef();
  const videoRef3 = useRef();
  const videoRef4 = useRef();
  const videoRef5 = useRef();
  const videoRef6 = useRef();
  const videoRefs = useRef();
  const {
    id,
    episode,
    map,
    photo,
    title,
    videoD,
    videoT,
    videoM,
    link,
    label,
    play,
    name,
    copy,
    button,
    date,
    disclaimer
  } = episodeData[dataIndex];
  videoRefs.current = [videoRef1, videoRef2, videoRef3, videoRef4, videoRef5, videoRef6];
  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.3) {
            episodeRef.current.style.opacity = '1';
          }
        });
      },
      { threshold: [0, 0.3] }
    );
    observer.observe(episodeRef.current);
  }, [episodeRef]);

  useEffect(() => {
    if (videoSrc && dataIndex < 4) {
      videoRefs.current[dataIndex].current.load();
    }
  }, [videoSrc, dataIndex]);

  return (
    <section className={`episode episode--${dataIndex}`} id={id}>
      {dataIndex < 6 && (
        <>
          <video
            autoPlay
            muted
            playsInline
            loop
            className={`episode__videoloop episode__videoloop--${dataIndex}`}
            ref={videoRefs.current[dataIndex]}
          >
            {videoSrc === 'small' && <source src={videoM} type="video/mp4" />}
            {videoSrc === 'medium' && <source src={videoT} type="video/mp4" />}
            {videoSrc === 'large' && <source src={videoD} type="video/mp4" />}
            Your browser does not support HTML5 video.
          </video>

          <div className={`episode__overlay  episode__overlay--${dataIndex}`} />
        </>
      )}

      {dataIndex === '6' ? (
        <div className={`episode-contents episode-contents--${dataIndex}`} ref={episodeRef}>
          <h2 className="videoTitle">{title}</h2>
          <p className="copy">{copy}</p>
          <div className="carouselButton">
            <a href={link} rel="sponsored" target="_blank" aria-label={label}>
              {button}
            </a>
          </div>
        </div>
      ) : (
        <div className={`episode-contents episode-contents--${dataIndex}`} ref={episodeRef}>
          <div className="episode__video">
            <p className="videoHead">I Want to Explore...</p>
            <h2 className="videoTitle">{title}</h2>
            {play ? (
              <Fragment>
                <a
                  href={link}
                  target="_blank"
                  rel="sponsored"
                  aria-label={label}
                  className="episode__button"
                >
                  <PlayIcon />
                </a>
                <p className="play">Play Episode {episode}</p>
              </Fragment>
            ) : (
              <h3 className="videoSubhead">
                episode {episode} coming soon in {date}
              </h3>
            )}
          </div>
          <div className="episode__body">
            <img
              className={
                episode < 5
                  ? `episode__body__map episode__body__map--${dataIndex}`
                  : `episode__body__map episode__body__map--s episode__body__map--${dataIndex}`
              }
              src={map}
              alt=""
            />
            <div
              className={
                episode > 5
                  ? `episode__body__traveler episode__body__traveler--margin  episode__body__traveler--${dataIndex}`
                  : `episode__body__traveler episode__body__traveler--${dataIndex}`
              }
            >
              <img
                className="episode__body__traveler__img"
                src={photo}
                alt=""
                aria-hidden="true"
                focusable="false"
              />
              <h3 className="bodyHeadline">Meet {name}</h3>
              <p className="copy">{copy}</p>
              {disclaimer ? <p className="episode__body__traveler__credit">{disclaimer}</p> : <></>}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Episode;
